import React from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import { getOnClickHref } from '../../utils/thirdPartyTracking/helpers';

const DescriptionContainer = styled.div`
    white-space: pre-line;
    a {
        color: #008eff;
        text-decoration: none;
    }
`;

const CustomDescription = props => {
    let { description, widgetId } = props;
    const shouldAppendOnClickLink = widgetId === 3371 || widgetId === 3278;

    const link = () => {
        const href = getOnClickHref(widgetId);
        if (href.length > 0) {
            return (
                <div>
                    Find out{' '}
                    <a
                        href={href}
                        className="link-default"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        more
                    </a>
                    .
                </div>
            );
        } else {
            return;
        }
    };

    return (
        <DescriptionContainer>
            <div
                dangerouslySetInnerHTML={{
                    __html: description
                }}
            />
            {shouldAppendOnClickLink && link()}
        </DescriptionContainer>
    );
};
CustomDescription.propTypes = {
    description: PropTypes.string,
    widgetId: PropTypes.number
};

export default CustomDescription;
